import { createNamespacedHelpers } from 'vuex'

const { mapGetters: technicianGetters, mapActions: technicianActions } =
  createNamespacedHelpers('userGroup/technician')
const { mapGetters: requesterGetters, mapActions: requesterActions } =
  createNamespacedHelpers('userGroup/requester')
const { mapGetters: userGetters, mapActions: userActions } =
  createNamespacedHelpers('userGroup/user')

export const UserGroupsComputed = {
  ...technicianGetters({
    technicianGroupsOptions: 'groupsAsOptions',
    technicianGetGroupById: 'getGroupById',
  }),
  ...requesterGetters({
    requesterGroupsOptions: 'groupsAsOptions',
    requesterGetGroupById: 'getGroupById',
  }),
  ...userGetters({
    userGroupsOptions: 'userGroupsAsOptions',
  }),
}

export const UserGroupsMethods = {
  ...technicianActions({ technicianGroups: 'fetch' }),
  ...requesterActions({ requesterGroups: 'fetch' }),
  ...userActions({ userGroups: 'fetch' }),
}
